<script setup>
import { withQuery } from "ufo";
import moment from "moment-timezone";

moment.tz.setDefault("Asia/Jakarta");

definePage({
  meta: {
    layout: "default",
  },
});
const route = useRoute();
const router = useRouter();

const pageTitle = "Data Location";

const breadCrumbs = [
  {
    title: "Dashboard",
    to: "/admin/dashboard",
  },
  {
    title: "Master Data",
    to: null,
  },
  {
    title: pageTitle,
    to: "/admin/location",
  },
  {
    title: "10000001",
    to: null,
  },
];

const { data: dataQuery } = await useApi(
  withQuery("/cms/location/" + route.params.id, {
    method: "GET",
  })
);
const data = dataQuery ? dataQuery.value?.data : [];

const statuses = [
  {
    title: "Installation scheduled",
    value: 11,
  },
  {
    title: "Open",
    value: 21,
  },
  {
    title: "Close",
    value: 22,
  },
  {
    title: "Released",
    value: 23,
  },
  {
    title: "Blocked",
    value: 31,
  },
  {
    title: "Suspicious",
    value: 41,
  },
  {
    title: "Removed",
    value: 51,
  },
];
// Use
const useItems = [
  {
    title: "Use",
    value: 0,
  },
  {
    title: "Not Use",
    value: 1,
  },
];
// Log
const useLogs = [
  {
    title: "Request",
    value: 1,
  },
  {
    title: "Receiving",
    value: 2,
  },
  {
    title: "Finish",
    value: 3,
  },
];
</script>

<template>
  <VBreadcrumbs :items="breadCrumbs" class="px-0 pt-0 pb-5" />
  <h4 class="text-h4 my-4">{{ pageTitle }} Detail</h4>
  <VRow>
    <VCol class="align-items-stretch" cols="12" lg="12" sm="12">
      <VCard border class="v-card-data" title="Location Information">
        <template #append>
          <VRow>
            <VCol cols="12" lg="4">
              <VForm>
                <VBtn block color="error" type="submit"> Stop</VBtn>
              </VForm>
            </VCol>
            <VCol cols="12" lg="8">
              <VBtn
                :to="{
                  path: '/admin/location/update/' + route.params.id,
                }"
                block
                color="primary"
              >
                <VIcon icon="tabler-pencil" start />
                Edit {{ pageTitle }}
              </VBtn>
            </VCol>
          </VRow>
        </template>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Location ID</td>
              <td>{{ data.id }}</td>
            </tr>
            <tr>
              <td>Status</td>
              <td>
                <AppSelect
                  v-model="data.status"
                  :items="statuses"
                  class="v-select-print"
                  readonly
                />
              </td>
            </tr>
            <tr>
              <td>Location Name</td>
              <td>{{ data.name }}</td>
            </tr>
            <tr>
              <td>Service start date</td>
              <td>
                {{
                  data.serviceStartDate
                    ? moment(data.serviceStartDate).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Service end date</td>
              <td>
                {{
                  data.serviceStartDate
                    ? moment(data.serviceEndDate).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Inst. times</td>
              <td>{{ data.installTime }}</td>
            </tr>
            <tr>
              <td>Last installation date</td>
              <td>
                {{
                  data.lastInstall
                    ? moment(data.lastInstall).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Latest blacklist distribution</td>
              <td>
                {{
                  data.blacklistDistribution
                    ? moment(data.blacklistDistribution).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Blacklist version on the server</td>
              <td>{{ data.blacklistOnServer }}</td>
            </tr>
            <tr>
              <td>Blacklist version on the terminal</td>
              <td>{{ data.blacklistOnTerminal }}</td>
            </tr>
            <tr>
              <td>Last open date</td>
              <td>
                {{ data.lastOpen ? moment(data.lastOpen).format("LL") : null }}
              </td>
            </tr>
            <tr>
              <td>Last daily authentication date</td>
              <td>
                {{
                  data.lastAuthentication
                    ? moment(data.lastAuthentication).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Last transaction date</td>
              <td>
                {{
                  data.lastTransaction
                    ? moment(data.lastTransaction).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Last close date</td>
              <td>
                {{
                  data.lastClose ? moment(data.lastClose).format("LL") : null
                }}
              </td>
            </tr>
            <tr>
              <td>Latest server connection</td>
              <td>
                {{
                  data.lastServerConnect
                    ? moment(data.lastServerConnect).format("LL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Terminal clock error</td>
              <td>{{ data.terminalClockError }}</td>
            </tr>
          </tbody>
        </VTable>
        <VDivider />
        <VCardText>
          <h6 class="text-h6">Terminal Permission</h6>
        </VCardText>

        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Sales</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.sales == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Sales cancel</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.salesCancel == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Reload</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.reload == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Cancel reload</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.cancelReload == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Offline card issue by online</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.offlineCardIssueByOnline == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Offline card issue by offline</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.offlineCardIssueByOffline == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Online card issue</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.onlineCardIssue == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Hybrid card issue</td>
              <td>
                {{
                  data
                    ? data.terminalPermission
                      ? data.terminalPermission.hybridCardIssue == 1
                        ? useItems[0].title
                        : useItems[1].title
                      : null
                    : null
                }}
              </td>
            </tr>
          </tbody>
        </VTable>
        <VDivider />
        <VCardText>
          <h6 class="text-h6">Transaction log information</h6>
        </VCardText>
        <VTable class="text-no-wrap" density="compact">
          <tbody>
            <tr>
              <td>Transaction log resend status</td>
              <td>
                <AppSelect
                  v-model="data.transactionLogResendStatus"
                  :items="useLogs"
                  class="v-select-print"
                  readonly
                />
              </td>
            </tr>
            <tr>
              <td>Transaction log resend start</td>
              <td>
                {{
                  data.transactionLogResendStart
                    ? moment(data.transactionLogResendStart).format("LLL")
                    : null
                }}
              </td>
            </tr>
            <tr>
              <td>Transaction log resend end</td>
              <td>
                {{
                  data.transactionLogResendEnd
                    ? moment(data.transactionLogResendEnd).format("LLL")
                    : null
                }}
              </td>
            </tr>
          </tbody>
        </VTable>
      </VCard>
      <div class="mx-auto text-center">
        <VBtn
          :to="{ path: '/admin/location' }"
          class="mt-5 mx-auto text-center"
          color="secondary"
        >
          <VIcon icon="tabler-refresh" start />
          Back to {{ pageTitle }} List
        </VBtn>
      </div>
    </VCol>
  </VRow>
</template>
